﻿package com.mgacreative.hotelru.feature.staff.di

import com.mgacreative.hotelru.feature.staff.ui.StaffViewModel
import com.mgacreative.hotelru.feature.staff.ui.ShiftPlannerViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getStaffFeatureModule() = module {
    viewModel { StaffViewModel(get(), get(), get(), get()) }
    viewModel { ShiftPlannerViewModel(get(), get()) }
}

